// ============================================================================
// OSINT Face Comparison Thresholds — Single Source of Truth (Frontend)
// ============================================================================
// Per audit Section J finding: 6 nilai threshold tersebar di 4 file tanpa
// single config. Consolidate ke file ini supaya tuning per demo cycle cuma
// touch 1 lokasi.
//
// ⚠ MIRROR: api/_thresholds.js HARUS punya nilai sama. Vercel Node functions
// tidak bisa import dari src/ (separate bundling), jadi dua file mirror.
// Saat update salah satu, update keduanya. Future: add eslint rule atau
// script check sync di pre-commit.
// ============================================================================

export const OSINT_THRESHOLDS = {
  // Face similarity (cosine 0..1) — cross-domain KTP vs sosmed profile pic
  face: {
    /** ≥0.80 = strong match (high confidence) */
    strong: 0.80,
    /** ≥0.60 = match (moderate confidence, default threshold display) */
    match: 0.60,
    /** ≥0.38 = possible match (low confidence, operator review).
     *  Lowered 0.45 → 0.38 sharpening 2026-05-19 — align dgn FACE_MATCH_THRESHOLD
     *  CLAUDE.md NeoVision. Avatar low-res (unavatar.io 150-300px) sering legit
     *  match di 0.38-0.45 range, sebelumnya buang tier `unlikely`. */
    possible: 0.38,
    /** ≥0.85 = AUTO badge trigger (combined dgn name match score) */
    auto: 0.85,
    /** ≥0.65 = biometric same (for ALIAS detection) */
    alias_biometric: 0.65,
  },

  // Name match (0..1 Levenshtein normalized) — ALIAS detection
  name: {
    /** <0.30 = nama sangat beda (untuk ALIAS detection: face same + name diff) */
    alias_max: 0.30,
  },

  // Photo compare service (api/face-compare.js)
  photoCompare: {
    /** ≥0.60 = match valid (KTP vs sosmed cross-domain) */
    similarity: 0.60,
  },
};

// Convenience exports — backward-compat dgn legacy const names yang sudah
// dipakai di module. Internal lookup `OSINT_THRESHOLDS.*` lebih disukai
// untuk kode baru.
export const FACE_COMPARE_THRESHOLD = OSINT_THRESHOLDS.photoCompare.similarity;
